import { render, staticRenderFns } from "./Employees.vue?vue&type=template&id=70df3bcb&scoped=true"
import script from "./Employees.vue?vue&type=script&lang=js"
export * from "./Employees.vue?vue&type=script&lang=js"
import style0 from "../../styles/autocomplete.scss?vue&type=style&index=0&id=70df3bcb&prod&scoped=true&lang=scss&external"
import style1 from "./Employees.vue?vue&type=style&index=1&id=70df3bcb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70df3bcb",
  null
  
)

export default component.exports